import { render, staticRenderFns } from "./ProductRow.vue?vue&type=template&id=e80a301c&scoped=true&"
import script from "./ProductRow.vue?vue&type=script&lang=js&"
export * from "./ProductRow.vue?vue&type=script&lang=js&"
import style0 from "./ProductRow.vue?vue&type=style&index=0&id=e80a301c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80a301c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VIcon,VImg,VProgressCircular})
